<template>
    <b-col xs="12" lg="12">
        <b-row>
            <b-col xs="12" lg="2" class="heading-icon">
                <img :src="model.icon" width="64px" height="64px"/> <h4>{{ $t('envoy') }}</h4>
            </b-col>
            <b-col xs="12" lg="10">
                <p>
                  {{ $t('protokolEnvoy') }}
                </p>
            </b-col>
        </b-row>

        <br />
        <br />

        <b-card-footer>
            <b-row>
                <b-col xs="8" lg="10">
                    <b-row>
                        <b-col xs="6" lg="5">
                            <SelectField name="platform" :label="this.$t('platform')" v-model="platform"
                                :labelCols="4"
                                :items="platforms"
                                :rules="{required: true}"
                            />
                        </b-col>
                        <b-col xs="6" lg="4">
                            <SelectField name="arch" :label="this.$t('arch')" v-model="arch"
                                :labelCols="4"
                                :items="['x64']"
                                :rules="{required: true}"
                            />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col xs="4" lg="2">
                    <b-button variant="success" @click="download">{{ $t('download') }}</b-button>
                </b-col>
            </b-row>
        </b-card-footer>
    </b-col>
</template>
<script>
import Select from "../../../components/form/Select.vue"

export default {
    components: {
        SelectField: Select
    },
    props: {
        model: {
            Type: Object,
            default: function() {
                return null
            }
        }
    },

    data: function() {
        return {
            platform: 'win32',
            arch: 'x64',
            platforms: [
            {
                value: "win32",
                text: "windows"
            },
            {
                value: "linux",
                text: "linux"
            },
            {
                value: "darwin",
                text: "macos"
            }
        ]
        }
    },

    methods: {
        download() {
            window.open(`${this.$env.get("INTEGRATION_HOST")}/envoy/download/${this.platform}/${this.arch}/latest`);
        }
    },

    mounted() {
    }
}
</script>
